import { Spinner } from "react-bootstrap";


interface FloatingLoadingCardProps {
    title: string;
}

export const FloatingLoadingCard: React.FunctionComponent<FloatingLoadingCardProps> = ({
    title
}) => {
    return (
        <div 
            className="modal show"
            id="myModal" 
            style={{
                display: "flex",
                zIndex: 10,
                transform: "translate(0, 0%)",
                transformOrigin: "center",
                pointerEvents: "none"
            }}>
            <div 
                className="modal-dialog" 
                role="document" 
                style={{
                    width: "100%",
                    alignSelf: "center",
                    justifySelf: "center"
                }}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                    <span aria-hidden="true"></span>
                </div>
                    <div className="modal-footer">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                </div>
            </div>
        </div>
    );
}